import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="min-h-screen flex items-center justify-center bg-bone font-mono text-xs tracking-widest uppercase text-muted-foreground">Chargement…</div>;
  if (user === null) return <Navigate to="/login" replace />;
  return children;
}
